import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the ConfigurationProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class ConfigurationProvider {

  constructor() {
  }

  apiUrl() {
    return sessionStorage.getItem("useTestsystem") === "true" ? localStorage.getItem("testApiUrl") : 'https://proxy.gastroflow.at/';
  }

  passwordResetUrl() {
    return this.apiUrl();
  }
}



// WEBPACK FOOTER //
// ./src/providers/configuration/configuration.ts